export const LANGUAGES = [
    {
        value: "en",
        label: "English",
        code: "EN-US",
        width: 0
    },
    {
        value: "fr",
        label: "Français (Canada)",
        code: "FR-CA",
        width: 0
    },
    {
        value: "es",
        label: "Español (Latam)",
        code: "ES-419",
        width: 0
    },
    {
        value: "ja",
        label: "日本語",
        code: "JA-JP",
        width: 0
    },
    {
        value: "de",
        label: "Deutsch",
        code: "DE-DE",
        width: 0
    },
    {
        value: "pl",
        label: "Polski",
        code: "PL-PL",
        width: 0
    },
    {
        value: "pt-BR",
        label: "Português (Brasil)",
        code: "PT-BR",
        width: 0
    },
    {
        value: "nl",
        label: "Nederlands",
        code: "NL-NL",
        width: 0
    },
    {
        value: "it",
        label: "Italiano",
        code: "IT-IT",
        width: 0
    },
    {
        value: "zh-Hans",
        label: "简体中文",
        code: "ZH-CN",
        width: 0
    },
    {
        value: "th",
        label: "ไทย",
        code: "TH-TH",
        width: 0
    },
    {
        value: "id",
        label: "Bahasa Indonesia",
        code: "ID-ID",
        width: 0
    },
    {
        value: "cs",
        label: "Čeština",
        code: "CS-CZ",
        width: 0
    },
    {
        value: "sv",
        label: "Svenska",
        code: "SV-SE",
        width: 0
    },
    {
        value: "tr",
        label: "Türkçe",
        code: "TR-TR",
        width: 0
    },
    {
        value: "ms",
        label: "Bahasa Malay",
        code: "MS-MY",
        width: 0
    },
    {
        value: "fr-FR",
        label: "Français (France)",
        code: "FR-FR",
        width: 0
    },
    {
        value: "ko-KR",
        label: "한국어",
        code: "KO-KR",
        width: 0
    },
    {
        value: "zh-TW",
        label: "繁體中文",
        code: "ZH-TW",
        width: 0
    },
    {
        value: "da-DK",
        label: "Dansk",
        code: "DA-DK",
        width: 0
    },
    {
        value: "fi-FI",
        label: "Suomi",
        code: "FI-FI",
        width: 0
    },
    {
        value: "hu-HU",
        label: "Magyar",
        code: "HU-HU",
        width: 0
    },
    {
        value: "nb-NO",
        label: "Norwegian Bokmål",
        code: "NB-NO",
        width: 0
    },
    {
        value: "sk-SK",
        label: "Slovenčina",
        code: "SK-SK",
        width: 0
    },
    {
        value: "pt-PT",
        label: "Português (Portugal)",
        code: "PT-PT",
        width: 0
    },
    {
        value: "ro-RO",
        label: "Română",
        code: "RO-RO",
        width: 0
    },
    {
        value: "es-ES",
        label: "Español (España)",
        code: "ES-ES",
        width: 0
    },
    {
        value: "bg-BG",
        label: "Български",
        code: "BG-BG",
        width: 0
    },
    {
        value: "el-GR",
        label: "Ελληνικά",
        code: "EL-GR",
        width: 0
    },
    {
        value: "et-EE",
        label: "Eesti keel",
        code: "ET-EE",
        width: 0
    },
    {
        value: "ka-GE",
        label: "ქართული",
        code: "KA-GE",
        width: 0
    },
    {
        value: "lt-LT",
        label: "Lietuvių kalba",
        code: "LT-LT",
        width: 0
    },
    {
        value: "lv-LV",
        label: "Latviešu valoda",
        code: "LV-LV",
        width: 0
    },
    {
        value: "ar-001",
        label: "العربية",
        code: "AR-001",
        width: 0
    }
];

export const toLanguageCode = (lang: string) => {
    const normalizedLang = typeof lang === "string" ? lang.toLowerCase() : lang;
    let selectedLang = LANGUAGES.find(l => l.value === lang || (l.value === "es" && normalizedLang === "es-419") || (l.value === "es-ES" && normalizedLang === "es-es"));
    return selectedLang ? selectedLang.code : lang;
};

export const LANGUAGE_DICTIONARY = {
    en: "en",
    fr: "fr-CA",
    es: "es-419",
    "es-419": "es-419",
    ja: "ja-JP",
    de: "de-DE",
    pl: "pl-PL",
    "pt-BR": "pt-BR",
    nl: "nl-NL",
    it: "it-IT",
    "zh-Hans": "zh-CN",
    th: "th-TH",
    id: "id-ID",
    cs: "cs-CZ",
    sv: "sv-SE",
    tr: "tr-TR",
    ms: "ms-MY",
    "fr-FR": "fr-FR",
    "ko-KR": "ko-KR",
    "zh-TW": "zh-TW",
    "da-DK": "da-DK",
    "fi-FI": "fi-FI",
    "hu-HU": "hu-HU",
    "nb-NO": "nb-NO",
    "sk-SK": "sk-SK",
    "pt-PT": "pt-PT",
    "ro-RO": "ro-RO",
    "es-ES": "es-ES",
    "bg-BG": "bg-BG",
    "el-GR": "el-GR",
    "et-EE": "et-EE",
    "ka-GE": "ka-GE",
    "lt-LT": "lt-LT",
    "lv-LV": "lv-LV",
    ar: "ar-001",
    "ar-001": "ar-001"
};
